import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { Heading } from 'blaze-ui/Heading/Heading'
import { DrawerInner } from './PostPreviewDrawerContent'
import { PostPreviewProps } from 'components/PostPreviewModal/Types'
import { PostPreviewProviders } from './Providers'
import { observer } from 'mobx-react-lite'
import { usePostPreviewStore } from './PostPreviewStoreProvider'
import { Button } from 'blaze-ui/Button'
import { useRootStore } from 'stores/RootStore'
import Styles from './PostPreviewDrawerV2.module.scss'

type DrawerV2Props = PostPreviewProps & Omit<DrawerProps, 'children'>

export const DrawerHeader = observer(() => {
  const store = usePostPreviewStore()
  const { drawersStore } = useRootStore()

  return (
    <Drawer.Top>
      <div className={Styles.backButton}>
        <Button
          variant="editor"
          size="lg"
          onPress={() => (store.canGoBack ? store.goBack() : drawersStore.closeDrawer())}
        >
          Back
        </Button>
      </div>
      <Drawer.Title asChild>
        <Heading level={5}>Post Preview</Heading>
      </Drawer.Title>
    </Drawer.Top>
  )
})

const PostPreviewDrawerV2 = observer(({ pollPreviewContentStream = true, ...props }: DrawerV2Props) => {
  return (
    <Drawer.Root modal={false} {...(props as DrawerProps)}>
      <Drawer.Portal>
        <Drawer.Overlay />
        <Drawer.Content fullHeight onOpenAutoFocus={(e) => e.preventDefault()}>
          <Drawer.InnerContent isSnappedTop>
            <DrawerHeader />
            <Drawer.Container>
              <DrawerInner {...props} pollPreviewContentStream={pollPreviewContentStream} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})

const PostPreviewDrawerV2Container = (props: PostPreviewProps) => {
  return (
    <PostPreviewProviders {...props}>
      <PostPreviewDrawerV2 {...props} />
    </PostPreviewProviders>
  )
}

export { PostPreviewDrawerV2Container as PostPreviewDrawerV2 }
